/* eslint-disable import/default */

import { toast } from "react-toastify";
import { FormattedMessage } from "react-intl";
import simpleFetch from "../../../utils/simpleFetch";
import {
    EMAIL_NOT_VERIFIED,
    EMAIL_VERIFIED,
} from "../../components/dashboard/clients/enums/memberActivationStatusTypes";
import React from "react";

const isObjectWithMoreThanOneKey = (obj) =>
    obj !== null && typeof obj === "object" && !Array.isArray(obj) && Object.keys(obj).length > 1;

export const isMemberActivated = async (member) => {
    /**
     * Check first if member email is verified on MSYS side.
     */
    if (member.emailVerified) {
        return EMAIL_VERIFIED;
    }

    const mintData = await getMintDataForMember(member.clientId, [member.memberId]);
    if (!mintData) {
        return EMAIL_NOT_VERIFIED;
    }
    const mintMembersResponse = mintData["members"];
    if (!Array.isArray(mintMembersResponse) || mintMembersResponse.length === 0) {
        return EMAIL_NOT_VERIFIED;
    }
    const mintMember = mintMembersResponse[0];

    // Return true only if MINT data confirms email is verified and matches
    if (isMintActivated(mintMember, member)) {
        return EMAIL_VERIFIED;
    }

    return EMAIL_NOT_VERIFIED;
};

export const isMintActivated = (mintMember, member) => {
    return mintMember.email_verified === true && mintMember.email_address === member.emailAddress;
};

export const getBatchMemberActivationStatuses = async (clientId, memberIds) => {
    return await getMintDataForMember(clientId, memberIds);
};

export const getMintDataForMember = async (clientId, memberIds = undefined) => {
    try {
        let path = `/v2/clients/${clientId}/mint`;
        let params = {};

        if (memberIds && Array.isArray(memberIds) && memberIds.length > 0) {
            params = { member_ids: memberIds.join(",") };
        }

        const data = await simpleFetch("get", path, { query: params });

        if (!isObjectWithMoreThanOneKey(data)) {
            throw new Error("An error has occurred while fetching MINT data.");
        }
        return data["data"];
    } catch (e) {
        toast(<FormattedMessage id="validation.customMessages.serverErrors.genericError" />, {
            type: toast.TYPE.ERROR,
            autoClose: false,
        });
    }
};



// WEBPACK FOOTER //
// ./src/utils/services/memberActivationStatusService.js